// authApi.js
import { API_CONFIG} from "../../utils/api-config";
import fetchWithAuth from "../../utils/apiAthurization";

export const SearchPatients = async (data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/opd/opd-search-patients?search=${data?.search}&&searchIn=${data?.searchIn}`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "opdentries fetching failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};